/*
 * DISTRIBUTION STATEMENT C. Distribution authorized to U.S. Government Agencies and their contractors; Critical
 * Technology; 19 October 2017. Other requests for this document shall be referred to Chemical and Biological
 * Technologies, Defense Threat Reduction Agency, 8725 John J Kingman Road, Fort Belvoir, VA 22060-6201.
 *
 * WARNING: This document contains technical data whose export is restricted by the Arms Export Control Act (Sec 2751
 * of Title 22, United States Code) or the Export Control Reform Act of 2018 (Chapter 58 Sections 4801-4852 of Title
 * 50, United States Code). Violations of these export laws are subject to severe criminal penalties. Disseminate in
 * accordance with provisions of DoD Directive 5230.25 and DoD Instruction 2040.02. DESTRUCTION NOTICE: For
 * unclassified, limited distribution documents, destroy by any method that will prevent disclosure of the contents
 * or reconstruction of the document.
 *
 * This material is based upon work supported by the Under Secretary of War for Research and Engineering under Air
 * Force Contract No. FA8702-15-D-0001 or FA8702-25-D-B002. Any opinions, findings, conclusions or recommendations
 * expressed in this material are those of the author(s) and do not necessarily reflect the views of the Under
 * Secretary of War for Research and Engineering.
 *
 * © 2026 Massachusetts Institute of Technology.
 *
 * The software/firmware is provided to you on an As-Is basis
 *
 * Delivered to the U.S. Government with Unlimited Rights, as defined in DFARS Part 252.227-7013 or 7014 (Feb 2014).
 * Notwithstanding any copyright notice, U.S. Government rights in this work are defined by DFARS 252.227-7013 or
 * DFARS 252.227-7014 as detailed above. Use of this work other than as specifically authorized by the U.S.
 * Government may violate any copyrights that exist in this work.
 *
 * This document contains Controlled Unclassified Information (CUI). Handling of this information is subject to the
 * controls identified in DFARS 252.204-7012 - SAFEGUARDING COVERED DEFENSE INFORMATION AND CYBER INCIDENT REPORTING.
 */

import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

// Material-UI
import { makeStyles } from 'tss-react/mui';

// React-Bootstrap
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'

const useStyles = makeStyles()({
  docList: {
    marginLeft: '32px',
    '& > div': {
      marginBottom: '15px',
    }
  },
});

export const GetDocumentsURI = (name) => {
  // If defined, cui_uri takes precedence over uri when in CUI runtime
  let docs = {
    helpDoc: {
      name: 'helpDoc',
      uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/rapids-user-guide.pdf',
      cui_uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/agent-user-guide.pdf'
    },
    helpDocChallenge: {
      name: 'helpDocChallenge',
      uri: window._env_.APP_SITE === 'challenge' ? 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/challenge-user-guide.pdf' : ''
    },
    ddValidationDoc: {
      name: 'ddValidationDoc',
      uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/rapids-validation-guide.pdf'
    },
    awsCliInstructionsDoc: {
      name: 'AwsCliInstructionsDoc',
      uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/aws_cli_instructions.pdf'
    },
    wearableDDEx: {
      name: 'wearableDDEx',
      uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/rapids-wearable-dd-example.csv'
    },
    surveyDDEx: {
      name: 'surveyDDEx',
      uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/rapids-survey-dd-example.csv'
    },
    harmonizedDDEx: {
      name: 'harmonizedDDEx',
      uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/rapids-harmony-dd.csv'
    },
    dlhelp0: {
      name: 'download package help',
      uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/download_package_help.pdf'
    },
    dlhelp1: {
      name: 'download technical help',
      uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/download_technical_help.pdf'
    }
  };

  if (window._env_?.CUI_APP) {
    return docs[name] ? (docs[name]?.cui_uri ? docs[name].cui_uri : docs[name].uri) : '';
  }
  return docs[name] ? docs[name].uri : '';
}

export const OpenDocumentsPage = (e, tag, target) => {
  if (e) {
    e.preventDefault();
  }
  if (tag) {
    let uri = GetDocumentsURI(tag);
    if (uri) {
      if (target){
        uri = uri.concat(target);
      }
      window.open(uri, '_blank').focus();
    }
  }
}

export const GotoDocumentsPage = (tag) => {
  if (tag) {
    let uri = GetDocumentsURI(tag);
    if (uri) {
      window.location.href = uri;
    }
  }
}

function DocumentsPage() {
  const { classes } = useStyles();
  let { name } = useParams();
  
  useEffect(() => {
    // console.log(name);
    if (name) {
      // Open document
      let uri = GetDocumentsURI(name);
      if (uri) {
        window.location.href =  uri;
      }
    }
  }, [name]);

  return (
    <div className='page-background'>
      <Container className='page-foreground'>
        <Row className='body-padding'>
          <h2><b>Documents</b></h2>
        </Row>
        
        <div className={classes.docList}>
          <Row>
            <a href={'/'} onClick={(e) => OpenDocumentsPage(e, window._env_.APP_SITE === 'challenge' ? 'helpDocChallenge' : 'helpDoc')}>
              Help Document and AWS Guide
            </a>
          </Row>

          <Row>
            <a href={'/'} onClick={(e) => OpenDocumentsPage(e, 'ddValidationDoc')}>
              Data Dictionary Validation
            </a>
          </Row>

          <Row>
            <a href={'/'} onClick={(e) => OpenDocumentsPage(e, 'wearableDDEx')}>
              Wearable Data Dictionary Example
            </a>
          </Row>

          <Row>
            <a href={'/'} onClick={(e) => OpenDocumentsPage(e, 'surveyDDEx')}>
              Survey Data Dictionary Example
            </a>
          </Row>

          <Row>
            <a href={'/'} onClick={(e) => OpenDocumentsPage(e, 'harmonizedDDEx')}>
              Harmonized Data Dictionary Example
            </a>
          </Row>
        </div>
      </Container>
    </div>
  );
}

export default (DocumentsPage);